import React, { FC } from 'react';
import { AuthCallback } from '~/components';

const MerchantAuthCallback: FC = () => <AuthCallback  flowKey="self-onboarding" />;

export default MerchantAuthCallback;
